import MappingTabs from './MappingTabs'
export default MappingTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/index.js